import { Link } from 'react-scroll'
import hero1 from '../../images/preview/hero-bg.jpg'
import slide1 from '../../images/preview/img-1.jpg'
import slide2 from '../../images/preview/img-2.jpg'
import slide3 from '../../images/preview/img-3.jpg'
import slide4 from '../../images/preview/img-4.jpg'
import slide5 from '../../images/preview/img-5.jpg'
import scroolimg from '../../images/preview/mouse-scroll.svg'

const Hero = () => {
    return (
        <section className="preview-hero" style={{ backgroundImage: `url(${hero1})` }}>
            <div className="container-fluid">
                <div className="preview-hero-wrap">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-12">
                            <div className="preview-middle-items">
                                <div className="preview-middle-text">
                                    <span className="poort-text poort-in-right">Best Wedding Theme</span>
                                    <h2 className="poort-text poort-in-left">Welcome to Bohu Theme</h2>
                                    <h4 className="poort-text poort-in-right">Make Your Dream Wedding Website</h4>
                                    <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href="https://1.envato.market/vPL4xO"
                                        className="theme-btn wow fadeInUp"
                                        data-wow-duration="1600ms"
                                    >
                                        Purchase Now
                                    </a>

                                    <div className="scrool">
                                        <Link to="demo" spy={true} smooth={true} offset={-100} duration={500}>
                                            <img src={scroolimg} alt="" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-12 col-md-12 col-12">
                            <div className="preview-hero-items">
                                <div className="preview-hero-item wow fadeInUp" data-wow-duration="1000ms">
                                    <img src={slide1} alt="" />
                                </div>
                                <div className="preview-hero-item wow fadeInUp" data-wow-duration="1200ms">
                                    <img src={slide2} alt="" />
                                </div>
                                <div className="preview-hero-item wow fadeInUp" data-wow-duration="1800ms">
                                    <img src={slide3} alt="" />
                                </div>
                                <div className="preview-hero-item wow fadeInUp" data-wow-duration="1000ms">
                                    <img src={slide4} alt="" />
                                </div>
                                <div className="preview-hero-item wow fadeInUp" data-wow-duration="1200ms">
                                    <img src={slide5} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Hero;
